import { buildBlob } from './fileDownload.helper';

import type { ExportFormat, ExportTable } from './export.types';

const KB = 1024;
const MB = KB * KB;

/** Size in bytes of the file `downloadTable` would generate for the table (Excel is built, so it is async). */
export const getFileSize = async (table: ExportTable, format: ExportFormat, name: string): Promise<number> =>
  (await buildBlob(table, format, name)).size;

/** "~12.3 KB" / "~1.2 MB": approximate, as the estimate leaves out the Brand and Category POI lookup. */
export const formatFileSize = (bytes: number): string =>
  bytes < MB ? `~${(bytes / KB).toFixed(1)} KB` : `~${(bytes / MB).toFixed(1)} MB`;
